import React, { FC } from 'react';

import { FormField, FormLabel, FormItem, FormError } from './styled';

export type FieldProps = {
    label: React.ReactNode;
    labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
    radio?: boolean;
    error?: string;
};

const Field: FC<FieldProps> = ({
    label,
    labelProps,
    radio,
    error,
    ...rest
}) => {
    return (
        <FormField isError={!!error} isRadio={!!radio} {...rest}>
            {label && <FormLabel {...labelProps}>{label}</FormLabel>}
            <FormItem>{rest.children}</FormItem>
            {error && <FormError>{error}</FormError>}
        </FormField>
    );
};

export default Field;
